import type { Dispatch } from 'react'
import type { FFmpeg } from '@ffmpeg/ffmpeg'
import type { ReauthModalOptions } from 'contexts/reducers/ui'

export const SET_FFMPEG_INSTANCE = 'SET_FFMPEG_INSTANCE'
export const SET_REAUTH_MODAL_OPTIONS = 'SET_REAUTH_MODAL_OPTIONS'

const UiActions = ({
  dispatch,
}: {
  dispatch: Dispatch<{ type: string; [key: string]: unknown }>
}) => ({
  setFfmpegInstance: (ffmpegInstance: FFmpeg) =>
    dispatch({
      type: SET_FFMPEG_INSTANCE,
      ffmpegInstance,
    }),
  setReauthModalOptions: (reauthModalOptions: ReauthModalOptions | null) =>
    dispatch({
      type: SET_REAUTH_MODAL_OPTIONS,
      reauthModalOptions,
    }),
})

export default UiActions
